export const WHO_AM_I_MOCK = {
  id: '2cd31f41-4b2b-48eb-9872-ef29f5eda15d',
  name: 'teste199@olist.com',
  document_number: '07047386000136',
  display_name: 'teste199@olist.com',
  email: 'teste199@olist.com',
  created_at: '2022-08-03T13:24:44.996100Z',
  signup_origin: 'self-signup',
  plan_type: 'lite',
  last_login: '2022-08-03T13:24:45.533257Z',
  is_admin: false,
  blocked_reason: 'lead',
  user_status: 'probing',
  subscription_status: 'never-paid',
  has_collections: false,
  signup_completed: false,
  features: ['collection_mode_auto_framing', 'oss'],
  first_steps_completed: false,
  lead_id: '867c92fd-6dec-41dc-b708-cf7ecb194d06',
  seller_tags: [
    {
      created_at: '2022-08-03T13:24:45.292101Z',
      id: 'ed056e5b-5e4d-4655-b1cf-469c344e8ab6',
      name: 'pricing_v4',
      seller_id: '2cd31f41-4b2b-48eb-9872-ef29f5eda15d',
      tag_type: 'generic',
      updated_at: '2022-08-03T13:24:45.292123Z',
    },
  ],
  terms_of_use_version: 5,
  seller_area: 'lead',
  permissions: [
    {
      id: '48e20308-ea6f-4d57-aeb6-8dd8200cd4db',
      seller: '2cd31f41-4b2b-48eb-9872-ef29f5eda15d',
      permission: 'offline_collection_by_pax',
      responsible_user_email: 'developers@olist.com',
      reason: 'Initial Setup',
      additional_information: null,
      permission_description: null,
      created_at: '2022-08-03T13:25:26.178168Z',
      updated_at: '2022-08-03T13:25:26.178194Z',
      active: false,
      history: [
        {
          active: false,
          reason: 'Initial Setup',
          permission: 'offline_collection_by_pax',
          updated_at: '2022-08-03T13:25:26.178194Z',
          additional_information: null,
          responsible_user_email: 'developers@olist.com',
        },
      ],
    },
    {
      id: '7aad781e-f209-4ca7-8582-6488e100bb38',
      seller: '2cd31f41-4b2b-48eb-9872-ef29f5eda15d',
      permission: 'can_delivery_by_pax',
      responsible_user_email: 'developers@olist.com',
      reason: 'Initial Setup',
      additional_information: null,
      permission_description: null,
      created_at: '2022-08-03T13:25:29.041013Z',
      updated_at: '2022-08-03T13:25:29.041035Z',
      active: false,
      history: [
        {
          active: false,
          reason: 'Initial Setup',
          permission: 'can_delivery_by_pax',
          updated_at: '2022-08-03T13:25:29.041035Z',
          additional_information: null,
          responsible_user_email: 'developers@olist.com',
        },
      ],
    },
    {
      id: 'c3b36e52-030a-4533-8c75-0b28801cd332',
      seller: '2cd31f41-4b2b-48eb-9872-ef29f5eda15d',
      permission: 'collection_mode_auto_framing',
      responsible_user_email: 'developers@olist.com',
      reason: 'Initial Setup',
      additional_information: null,
      permission_description: null,
      created_at: '2022-08-03T13:25:37.246456Z',
      updated_at: '2022-08-03T13:25:37.246476Z',
      active: true,
      history: [
        {
          active: true,
          reason: 'Initial Setup',
          permission: 'collection_mode_auto_framing',
          updated_at: '2022-08-03T13:25:37.246476Z',
          additional_information: null,
          responsible_user_email: 'developers@olist.com',
        },
      ],
    },
    {
      id: '52f10afd-4284-458b-ab83-f1b24d675f5a',
      seller: '2cd31f41-4b2b-48eb-9872-ef29f5eda15d',
      permission: 'jadlog_only',
      responsible_user_email: 'developers@olist.com',
      reason: 'Initial Setup',
      additional_information: null,
      permission_description: null,
      created_at: '2022-08-03T13:25:16.506862Z',
      updated_at: '2022-08-03T13:25:16.506887Z',
      active: false,
      history: [
        {
          active: false,
          reason: 'Initial Setup',
          permission: 'jadlog_only',
          updated_at: '2022-08-03T13:25:16.506887Z',
          additional_information: null,
          responsible_user_email: 'developers@olist.com',
        },
      ],
    },
    {
      id: '78053315-806a-461f-8101-cbd6f13b20e1',
      seller: '2cd31f41-4b2b-48eb-9872-ef29f5eda15d',
      permission: 'can_print_zpl_label',
      responsible_user_email: 'developers@olist.com',
      reason: 'Initial Setup',
      additional_information: null,
      permission_description: null,
      created_at: '2022-08-03T13:25:23.360844Z',
      updated_at: '2022-08-03T13:25:23.360865Z',
      active: false,
      history: [
        {
          active: false,
          reason: 'Initial Setup',
          permission: 'can_print_zpl_label',
          updated_at: '2022-08-03T13:25:23.360865Z',
          additional_information: null,
          responsible_user_email: 'developers@olist.com',
        },
      ],
    },
    {
      id: '60feb19a-ac32-4a6f-9904-7d9e7e2c311e',
      seller: '2cd31f41-4b2b-48eb-9872-ef29f5eda15d',
      permission: 'can_delivery_by_meli_flex',
      responsible_user_email: 'developers@olist.com',
      reason: 'Initial Setup',
      additional_information: null,
      permission_description:
        'Esta permission tem o objetivo de identificar todos os sellers que est\u00e3o no fluxo de Mercado Envios Flex do Mercado Livre',
      created_at: '2022-08-03T13:25:40.264464Z',
      updated_at: '2022-08-03T13:25:40.264483Z',
      active: false,
      history: [
        {
          active: false,
          reason: 'Initial Setup',
          permission: 'can_delivery_by_meli_flex',
          updated_at: '2022-08-03T13:25:40.264483Z',
          additional_information: null,
          responsible_user_email: 'developers@olist.com',
        },
      ],
    },
    {
      id: '5134afba-4803-485a-9d41-b43d694a140a',
      seller: '2cd31f41-4b2b-48eb-9872-ef29f5eda15d',
      permission: 'can_delivery_by_jadlog',
      responsible_user_email: 'developers@olist.com',
      reason: 'Initial Setup',
      additional_information: null,
      permission_description: null,
      created_at: '2022-08-03T13:25:15.341320Z',
      updated_at: '2022-08-03T13:25:15.341345Z',
      active: false,
      history: [
        {
          active: false,
          reason: 'Initial Setup',
          permission: 'can_delivery_by_jadlog',
          updated_at: '2022-08-03T13:25:15.341345Z',
          additional_information: null,
          responsible_user_email: 'developers@olist.com',
        },
      ],
    },
    {
      id: '16f8f60d-59d5-47cf-acc0-c16f331eae38',
      seller: '2cd31f41-4b2b-48eb-9872-ef29f5eda15d',
      permission: 'can_delivery_by_loggi',
      responsible_user_email: 'developers@olist.com',
      reason: 'Initial Setup',
      additional_information: null,
      permission_description: null,
      created_at: '2022-08-03T13:25:17.289724Z',
      updated_at: '2022-08-03T13:25:17.289744Z',
      active: false,
      history: [
        {
          active: false,
          reason: 'Initial Setup',
          permission: 'can_delivery_by_loggi',
          updated_at: '2022-08-03T13:25:17.289744Z',
          additional_information: null,
          responsible_user_email: 'developers@olist.com',
        },
      ],
    },
    {
      id: 'daeba45b-a7d8-4849-8f45-759150ec7e79',
      seller: '2cd31f41-4b2b-48eb-9872-ef29f5eda15d',
      permission: 'correios_industrial_tier',
      responsible_user_email: 'developers@olist.com',
      reason: 'Initial Setup',
      additional_information: null,
      permission_description: null,
      created_at: '2022-08-03T13:25:19.805208Z',
      updated_at: '2022-08-03T13:25:19.805234Z',
      active: false,
      history: [
        {
          active: false,
          reason: 'Initial Setup',
          permission: 'correios_industrial_tier',
          updated_at: '2022-08-03T13:25:19.805234Z',
          additional_information: null,
          responsible_user_email: 'developers@olist.com',
        },
      ],
    },
    {
      id: 'de7592e1-582d-44d9-96b5-6abcd3cf4ab6',
      seller: '2cd31f41-4b2b-48eb-9872-ef29f5eda15d',
      permission: 'can_use_invoicer',
      responsible_user_email: 'developers@olist.com',
      reason: 'Initial Setup',
      additional_information: null,
      permission_description: null,
      created_at: '2022-08-03T13:25:33.126142Z',
      updated_at: '2022-08-03T13:25:33.126164Z',
      active: false,
      history: [
        {
          active: false,
          reason: 'Initial Setup',
          permission: 'can_use_invoicer',
          updated_at: '2022-08-03T13:25:33.126164Z',
          additional_information: null,
          responsible_user_email: 'developers@olist.com',
        },
      ],
    },
    {
      id: 'b30df595-252b-4090-9ad9-55c197a2c211',
      seller: '2cd31f41-4b2b-48eb-9872-ef29f5eda15d',
      permission: 'parcel_collection_by_pax',
      responsible_user_email: 'developers@olist.com',
      reason: 'Initial Setup',
      additional_information: null,
      permission_description: null,
      created_at: '2022-08-03T13:25:21.926893Z',
      updated_at: '2022-08-03T13:25:21.926918Z',
      active: false,
      history: [
        {
          active: false,
          reason: 'Initial Setup',
          permission: 'parcel_collection_by_pax',
          updated_at: '2022-08-03T13:25:21.926918Z',
          additional_information: null,
          responsible_user_email: 'developers@olist.com',
        },
      ],
    },
    {
      id: 'a0ab1723-c853-493b-a721-4ceb9eb21a91',
      seller: '2cd31f41-4b2b-48eb-9872-ef29f5eda15d',
      permission: 'on_demand_collection_by_pax',
      responsible_user_email: 'developers@olist.com',
      reason: 'Initial Setup',
      additional_information: null,
      permission_description: null,
      created_at: '2022-08-03T13:25:24.769155Z',
      updated_at: '2022-08-03T13:25:24.769176Z',
      active: false,
      history: [
        {
          active: false,
          reason: 'Initial Setup',
          permission: 'on_demand_collection_by_pax',
          updated_at: '2022-08-03T13:25:24.769176Z',
          additional_information: null,
          responsible_user_email: 'developers@olist.com',
        },
      ],
    },
    {
      id: 'a725574c-531a-48be-b5ce-8ebe45843a7d',
      seller: '2cd31f41-4b2b-48eb-9872-ef29f5eda15d',
      permission: 'can_send_to_zpl_printer',
      responsible_user_email: 'developers@olist.com',
      reason: 'Initial Setup',
      additional_information: null,
      permission_description: null,
      created_at: '2022-08-03T13:25:27.575249Z',
      updated_at: '2022-08-03T13:25:27.575268Z',
      active: false,
      history: [
        {
          active: false,
          reason: 'Initial Setup',
          permission: 'can_send_to_zpl_printer',
          updated_at: '2022-08-03T13:25:27.575268Z',
          additional_information: null,
          responsible_user_email: 'developers@olist.com',
        },
      ],
    },
    {
      id: 'f24e5fec-8130-4057-a21f-d6a066d424de',
      seller: '2cd31f41-4b2b-48eb-9872-ef29f5eda15d',
      permission: 'oss',
      responsible_user_email: 'developers@olist.com',
      reason: 'Initial Setup',
      additional_information: null,
      permission_description: null,
      created_at: '2022-08-03T13:25:18.655594Z',
      updated_at: '2022-08-03T13:25:18.655615Z',
      active: true,
      history: [
        {
          active: true,
          reason: 'Initial Setup',
          permission: 'oss',
          updated_at: '2022-08-03T13:25:18.655615Z',
          additional_information: null,
          responsible_user_email: 'developers@olist.com',
        },
      ],
    },
    {
      id: '8bbb00d4-9f60-4a0b-983f-3d4d5425e6ef',
      seller: '2cd31f41-4b2b-48eb-9872-ef29f5eda15d',
      permission: 'notify_correios_industrial_tier',
      responsible_user_email: 'developers@olist.com',
      reason: 'Initial Setup',
      additional_information: null,
      permission_description: null,
      created_at: '2022-08-03T13:25:21.176402Z',
      updated_at: '2022-08-03T13:25:21.176429Z',
      active: false,
      history: [
        {
          active: false,
          reason: 'Initial Setup',
          permission: 'notify_correios_industrial_tier',
          updated_at: '2022-08-03T13:25:21.176429Z',
          additional_information: null,
          responsible_user_email: 'developers@olist.com',
        },
      ],
    },
    {
      id: 'caead0d2-2929-435f-ad04-3dc627f8c504',
      seller: '2cd31f41-4b2b-48eb-9872-ef29f5eda15d',
      permission: 'me2_mx_should_skip_quote',
      responsible_user_email: 'developers@olist.com',
      reason: 'Initial Setup',
      additional_information: null,
      permission_description: null,
      created_at: '2022-08-03T13:25:28.337603Z',
      updated_at: '2022-08-03T13:25:28.337624Z',
      active: false,
      history: [
        {
          active: false,
          reason: 'Initial Setup',
          permission: 'me2_mx_should_skip_quote',
          updated_at: '2022-08-03T13:25:28.337624Z',
          additional_information: null,
          responsible_user_email: 'developers@olist.com',
        },
      ],
    },
    {
      id: '46038e98-5b44-4d09-b468-fef9ae23da23',
      seller: '2cd31f41-4b2b-48eb-9872-ef29f5eda15d',
      permission: 'out_max_package_measures',
      responsible_user_email: 'developers@olist.com',
      reason: 'Initial Setup',
      additional_information: null,
      permission_description: null,
      created_at: '2022-08-03T13:25:34.608035Z',
      updated_at: '2022-08-03T13:25:34.608057Z',
      active: false,
      history: [
        {
          active: false,
          reason: 'Initial Setup',
          permission: 'out_max_package_measures',
          updated_at: '2022-08-03T13:25:34.608057Z',
          additional_information: null,
          responsible_user_email: 'developers@olist.com',
        },
      ],
    },
    {
      id: '83640257-a1cb-42f0-96ee-93cc140e455f',
      seller: '2cd31f41-4b2b-48eb-9872-ef29f5eda15d',
      permission: 'can_delivery_heavy_by_olist',
      responsible_user_email: 'developers@olist.com',
      reason: 'Initial Setup',
      additional_information: null,
      permission_description: null,
      created_at: '2022-08-03T13:25:36.091537Z',
      updated_at: '2022-08-03T13:25:36.091559Z',
      active: false,
      history: [
        {
          active: false,
          reason: 'Initial Setup',
          permission: 'can_delivery_heavy_by_olist',
          updated_at: '2022-08-03T13:25:36.091559Z',
          additional_information: null,
          responsible_user_email: 'developers@olist.com',
        },
      ],
    },
    {
      id: 'c11f5529-6500-4262-8976-8ad03d5d0803',
      seller: '2cd31f41-4b2b-48eb-9872-ef29f5eda15d',
      permission: 'can_use_fulfillment_by_olist',
      responsible_user_email: 'developers@olist.com',
      reason: 'Initial Setup',
      additional_information: null,
      permission_description: null,
      created_at: '2022-08-03T13:25:30.194822Z',
      updated_at: '2022-08-03T13:25:30.194850Z',
      active: false,
      history: [
        {
          active: false,
          reason: 'Initial Setup',
          permission: 'can_use_fulfillment_by_olist',
          updated_at: '2022-08-03T13:25:30.194850Z',
          additional_information: null,
          responsible_user_email: 'developers@olist.com',
        },
      ],
    },
    {
      id: '125d0d37-ef1d-4f0f-b461-aad058cefd22',
      seller: '2cd31f41-4b2b-48eb-9872-ef29f5eda15d',
      permission: '1p_operation',
      responsible_user_email: 'developers@olist.com',
      reason: 'Initial Setup',
      additional_information: null,
      permission_description:
        'Esta permission tem o objetivo de identificar todas as contas de 1P do Olist',
      created_at: '2022-08-03T13:25:38.707701Z',
      updated_at: '2022-08-03T13:25:38.707725Z',
      active: false,
      history: [
        {
          active: false,
          reason: 'Initial Setup',
          permission: '1p_operation',
          updated_at: '2022-08-03T13:25:38.707725Z',
          additional_information: null,
          responsible_user_email: 'developers@olist.com',
        },
      ],
    },
    {
      id: '20fa9af9-6a21-4ff0-a043-7a758cfd07f1',
      seller: '2cd31f41-4b2b-48eb-9872-ef29f5eda15d',
      permission: 'can_delivery_by_me2',
      responsible_user_email: 'developers@olist.com',
      reason: 'Initial Setup',
      additional_information: null,
      permission_description:
        'Esta permission tem o objetivo de identificar todos os sellers que est\u00e3o no fluxo de ME2 do Mercado Livre',
      created_at: '2022-08-03T13:25:41.444341Z',
      updated_at: '2022-08-03T13:25:41.444360Z',
      active: false,
      history: [
        {
          active: false,
          reason: 'Initial Setup',
          permission: 'can_delivery_by_me2',
          updated_at: '2022-08-03T13:25:41.444360Z',
          additional_information: null,
          responsible_user_email: 'developers@olist.com',
        },
      ],
    },
  ],
};

export const FIRST_STEPS_MOCK = {
  completed_steps: [],
  active_debt_document: {},
  invoice_status: '',
  bank_slip_expiration_date: null,
  subscription: {
    id: 'c26b27f9-5bc5-4272-b80a-5f1bd02ebafd',
    region: 'br',
    price: '0.00',
    seller_id: '2cd31f41-4b2b-48eb-9872-ef29f5eda15d',
    setup_fee: '32.90',
    recurring_payment_value: '32.90',
    status: 'pending',
    created_at: '2022-08-03T13:24:59.402843Z',
    representative_email: '',
    discount_percentual: 0,
    discount_initial_date: null,
    discount_period: 0,
    discounts: 'NullDiscount(period=ForeverPeriod())',
    payment_day: 0,
    customer_payment_method_id: '',
    due_day: null,
    installments: 1,
    periodicity: 1,
    net_value: '32.90',
    plan: {
      id: '0ba8780e-353c-4603-8d95-b6583350f707',
      name: 'lite',
      slug: 'lite_v8',
      setup_fee: '32.90',
      recurring_payment_value: '32.90',
      max_revenue_amount: 0,
      commission_max_limit: '0.2300',
      commission_min_limit: '0.2300',
      freight_flat_fee_max_limit: '5.00',
      no_freight_flat_fee_threshold: '79.00',
      unique_commission: true,
      catalog_limit: 30,
      has_collect: false,
      catalog_without_barcode: false,
      default: true,
      active: true,
      region: 'br',
    },
    plan_billing: {
      id: '0540d159-8408-4c07-873a-8349b5e18cc7',
      periodicity: 1,
      amount: '32.90',
      plan_id: '0ba8780e-353c-4603-8d95-b6583350f707',
      recurring_payment_value: '32.90',
    },
    commissions: { default: 0.23 },
    coupon: null,
    freight_flat_fees: [
      { flat_fee: '5.00', price_range: { lower: '0', upper: '79.00', bounds: '[)' } },
    ],
    is_free: false,
    is_recurring: false,
    credit_cards: [],
  },
};

export const PERSONAL_INFORMATIONS_MOCK = {
  company: {
    company_name: 'Teste razão social',
    brand: 'Teste razão social',
    cnpj: '07047386000136',
    is_manufacturer: false,
    crt: '1',
    ie: '',
  },
  address: {
    postal_code: '45028075',
    street: 'Avenida Alziro Prates',
    number: '23',
    complement: 'Casa',
    reference: '',
    city: 'Vitória da Conquista',
    neighbourhood: 'Candeias',
    state: 'BA',
  },
  responsible: {
    cpf: '038.455.080-00',
    email: 'teste199@olist.com',
    phone: '(11) 11111-1111',
    mobile_phone: '+5511111111111',
    name: 'teste199@olist.com',
  },
};

export const VIA_CEP_MOCK = {
  addressInfo: {
    cep: '49007-325',
    logradouro: 'Rua Vinte e Oito',
    complemento: '',
    bairro: 'Areia Branca',
    localidade: 'Aracaju',
    uf: 'SE',
    ibge: '2800308',
    gia: '',
    ddd: '79',
    siafi: '3105',
  },
  hasHubCoverage: true,
};

export const SELLER_TAGS_MOCK = {
  sellerTags: ['company_account', 'first_product', 'implementation', 'bank_account'],
};

export const PLANS_CHOISE_V2_MOCK = {
  plans: [
    {
      planId: 'eb966205-b43d-45eb-a7d4-5a498a70fe3d',
      billings: [
        {
          amount: '49.00',
          planBillingId: '1a0436a1-be9f-497a-8dd5-646d9a5ff1ca',
          planId: 'eb966205-b43d-45eb-a7d4-5a498a70fe3d',
          periodicity: 1,
          recurringPayment: '49.00',
          slug: 'growth',
          discount: null,
          description: {
            title: 'Crescer',
            description: 'Para empresas que faturam até R$ 1 milhão por mês',
            advantages: [],
            advantagesTitle: null,
            featured: false,
            percentage: null,
            originalValue: null,
            selfChoose: true,
          },
        },
        {
          amount: '468.00',
          planBillingId: 'd3a674ba-e048-43e2-bba0-be9f80063edd',
          planId: 'eb966205-b43d-45eb-a7d4-5a498a70fe3d',
          periodicity: 12,
          recurringPayment: '39.00',
          slug: 'growth',
          discount: { percentage: '20% off', originalValue: '49,00', subText: null },
          description: {
            title: 'Crescer',
            description: 'Para empresas que faturam até R$ 1 milhão por mês',
            advantages: [],
            advantagesTitle: null,
            featured: false,
            percentage: '20% off',
            originalValue: '49,00',
            selfChoose: true,
          },
        },
      ],
      catalogLimit: 0,
      commission: 23,
      hasCollect: true,
      name: 'growth',
      recurringPayment: '0.00',
      slug: 'growth',
      uniqueCommission: true,
    },
    {
      planId: '1b84d384-619b-4508-b2d3-1b27a70d1bfe',
      billings: [
        {
          amount: '295.00',
          planBillingId: '5ce64fb8-a725-4f36-bb47-a2e152825711',
          planId: '1b84d384-619b-4508-b2d3-1b27a70d1bfe',
          periodicity: 1,
          recurringPayment: '295.00',
          slug: 'evolve',
          discount: null,
          description: {
            title: 'Evoluir',
            description: 'Para empresas que faturam entre R$ 1 milhão e R$ 3 milhões por mês',
            advantages: ['Implementação guiada', 'Desconto de 50% no Tiny'],
            advantagesTitle: 'Tenha tudo do plano Crescer mais:',
            featured: true,
            selfChoose: true,
          },
        },
        {
          amount: '2124.00',
          planBillingId: '5bcac461-43a9-4867-99d7-4c00f704ef7c',
          planId: '1b84d384-619b-4508-b2d3-1b27a70d1bfe',
          periodicity: 12,
          recurringPayment: '177.00',
          slug: 'evolve',
          discount: { percentage: '40% off', originalValue: '295,00', subText: null },
          description: {
            title: 'Evoluir',
            description: 'Para empresas que faturam entre R$ 1 milhão e R$ 3 milhões por mês',
            advantages: ['Implementação guiada', 'Desconto de 50% no Tiny'],
            advantagesTitle: 'Tenha tudo do plano Crescer mais:',
            featured: true,
            percentage: '40% OFF',
            originalValue: '295,00',
            selfChoose: true,
          },
        },
      ],
      catalogLimit: 0,
      commission: 21,
      hasCollect: true,
      name: 'evolve',
      recurringPayment: '0.00',
      slug: 'evolve',
      uniqueCommission: true,
    },
    {
      planId: '0c381e9e-9334-4798-b619-740307b21163',
      billings: [
        {
          amount: '1399.00',
          planBillingId: 'f4a27559-908a-4b32-b9d6-57b2f669408b',
          planId: '0c381e9e-9334-4798-b619-740307b21163',
          periodicity: 1,
          recurringPayment: '1399.00',
          slug: 'potentialize',
          discount: null,
          description: {
            title: 'Potencializar',
            description: 'Para empresas que faturam acima de R$ 3 milhões por mês',
            advantages: [
              'Implementação guiada',
              'Desconto de 100% no Tiny',
              'Incentivos do Olist',
              'Gerente de contas',
            ],
            advantagesTitle: 'Tenha tudo do plano Evoluir mais:',
            featured: false,
            selfChoose: false,
          },
        },
        {
          amount: '8388.00',
          planBillingId: '4a5e41a0-d073-415c-88a8-3fd3ad88dc5a',
          planId: '0c381e9e-9334-4798-b619-740307b21163',
          periodicity: 12,
          recurringPayment: '699.00',
          slug: 'potentialize',
          discount: { percentage: null, originalValue: null, subText: null },
          description: {
            title: 'Potencializar',
            description: 'Para empresas que faturam acima de R$ 3 milhões por mês',
            advantages: [
              'Implementação guiada',
              'Desconto de 100% no Tiny',
              'Incentivos do Olist',
              'Gerente de contas',
            ],
            advantagesTitle: 'Tenha tudo do plano Evoluir mais:',
            featured: false,
            percentage: null,
            originalValue: null,
            selfChoose: false,
          },
        },
      ],
      catalogLimit: 0,
      commission: 21,
      hasCollect: true,
      name: 'potentialize',
      recurringPayment: '0.00',
      slug: 'potentialize',
      uniqueCommission: true,
    },
  ],
  plansFormatted: {
    '1': [
      {
        amount: '49.00',
        planBillingId: '1a0436a1-be9f-497a-8dd5-646d9a5ff1ca',
        planId: 'eb966205-b43d-45eb-a7d4-5a498a70fe3d',
        periodicity: 1,
        recurringPayment: '49.00',
        slug: 'growth',
        discount: null,
        description: {
          title: 'Crescer',
          description: 'Para empresas que faturam até R$ 1 milhão por mês',
          advantages: [],
          advantagesTitle: null,
          featured: false,
          percentage: null,
          originalValue: null,
          selfChoose: true,
        },
        plan: 'growth',
        commission: 23,
        amountPerMonth: 49,
      },
      {
        amount: '295.00',
        planBillingId: '5ce64fb8-a725-4f36-bb47-a2e152825711',
        planId: '1b84d384-619b-4508-b2d3-1b27a70d1bfe',
        periodicity: 1,
        recurringPayment: '295.00',
        slug: 'evolve',
        discount: null,
        description: {
          title: 'Evoluir',
          description: 'Para empresas que faturam entre R$ 1 milhão e R$ 3 milhões por mês',
          advantages: ['Implementação guiada', 'Desconto de 50% no Tiny'],
          advantagesTitle: 'Tenha tudo do plano Crescer mais:',
          featured: true,
          selfChoose: true,
        },
        plan: 'evolve',
        commission: 21,
        amountPerMonth: 295,
      },
      {
        amount: '1399.00',
        planBillingId: 'f4a27559-908a-4b32-b9d6-57b2f669408b',
        planId: '0c381e9e-9334-4798-b619-740307b21163',
        periodicity: 1,
        recurringPayment: '1399.00',
        slug: 'potentialize',
        discount: null,
        description: {
          title: 'Potencializar',
          description: 'Para empresas que faturam acima de R$ 3 milhões por mês',
          advantages: [
            'Implementação guiada',
            'Desconto de 100% no Tiny',
            'Incentivos do Olist',
            'Gerente de contas',
          ],
          advantagesTitle: 'Tenha tudo do plano Evoluir mais:',
          featured: false,
          selfChoose: false,
        },
        plan: 'potentialize',
        commission: 21,
        amountPerMonth: 1399,
      },
    ],
    '12': [
      {
        amount: '468.00',
        planBillingId: 'd3a674ba-e048-43e2-bba0-be9f80063edd',
        planId: 'eb966205-b43d-45eb-a7d4-5a498a70fe3d',
        periodicity: 12,
        recurringPayment: '39.00',
        slug: 'growth',
        discount: { percentage: '20% off', originalValue: '49,00', subText: null },
        description: {
          title: 'Crescer',
          description: 'Para empresas que faturam até R$ 1 milhão por mês',
          advantages: [],
          advantagesTitle: null,
          featured: false,
          percentage: '20% off',
          originalValue: '49,00',
          selfChoose: true,
        },
        plan: 'growth',
        commission: 23,
        amountPerMonth: 39,
      },
      {
        amount: '2124.00',
        planBillingId: '5bcac461-43a9-4867-99d7-4c00f704ef7c',
        planId: '1b84d384-619b-4508-b2d3-1b27a70d1bfe',
        periodicity: 12,
        recurringPayment: '177.00',
        slug: 'evolve',
        discount: { percentage: '40% off', originalValue: '295,00', subText: null },
        description: {
          title: 'Evoluir',
          description: 'Para empresas que faturam entre R$ 1 milhão e R$ 3 milhões por mês',
          advantages: ['Implementação guiada', 'Desconto de 50% no Tiny'],
          advantagesTitle: 'Tenha tudo do plano Crescer mais:',
          featured: true,
          percentage: '40% OFF',
          originalValue: '295,00',
          selfChoose: true,
        },
        plan: 'evolve',
        commission: 21,
        amountPerMonth: 177,
      },
      {
        amount: '8388.00',
        planBillingId: '4a5e41a0-d073-415c-88a8-3fd3ad88dc5a',
        planId: '0c381e9e-9334-4798-b619-740307b21163',
        periodicity: 12,
        recurringPayment: '699.00',
        slug: 'potentialize',
        discount: { percentage: null, originalValue: null, subText: null },
        description: {
          title: 'Potencializar',
          description: 'Para empresas que faturam acima de R$ 3 milhões por mês',
          advantages: [
            'Implementação guiada',
            'Desconto de 100% no Tiny',
            'Incentivos do Olist',
            'Gerente de contas',
          ],
          advantagesTitle: 'Tenha tudo do plano Evoluir mais:',
          featured: false,
          percentage: null,
          originalValue: null,
          selfChoose: false,
        },
        plan: 'potentialize',
        commission: 21,
        amountPerMonth: 699,
      },
    ],
  },
  showingOrder: ['growth', 'evolve', 'potentialize'],
  hasPersonalData: true,
  plansNames: { growth: 'growth', evolve: 'evolve', potentialize: 'potentialize' },
  periodicities: [1, 12],
  maxDiscount: { '1': null, '12': 'até 40% off' },
};

export const PLAN_CHOISES_MOCK = {
  showingOrder: ['lite_v8', 'basic_v8', 'pro_v8'],
  rules: [
    { slug: 'lite_v8', uniqueCommission: true, catalogLimit: 30, hasCollect: false },
    { slug: 'basic_v8', uniqueCommission: true, catalogLimit: 60, hasCollect: true },
    { slug: 'pro_v8', uniqueCommission: true, catalogLimit: 0, hasCollect: true },
  ],
  plans: [
    {
      planId: '0ba8780e-353c-4603-8d95-b6583350f707',
      billings: [
        {
          amount: '32.90',
          planBillingId: '0540d159-8408-4c07-873a-8349b5e18cc7',
          planId: '0ba8780e-353c-4603-8d95-b6583350f707',
          periodicity: 1,
          recurringPayment: '32.90',
          slug: 'lite_v8',
          discount: {
            percentage: '15% OFF*',
            originalValue: '39,00',
            subText: '*desconto válido no 1º mês',
          },
        },
        {
          amount: '162.00',
          planBillingId: 'f2fa0b54-7fe0-46c1-be98-f8944abe4cd3',
          planId: '0ba8780e-353c-4603-8d95-b6583350f707',
          periodicity: 6,
          recurringPayment: '27.00',
          slug: 'lite_v8',
          discount: { percentage: '30% OFF', originalValue: '234,00', subText: null },
        },
        {
          amount: '227.90',
          planBillingId: '3169fdfe-cae3-4674-954d-290f18beaa04',
          planId: '0ba8780e-353c-4603-8d95-b6583350f707',
          periodicity: 12,
          recurringPayment: '18.99',
          slug: 'lite_v8',
          discount: { percentage: '50% OFF', originalValue: '468,00', subText: null },
        },
      ],
      catalogLimit: 30,
      commission: 23,
      hasCollect: false,
      name: 'lite',
      recurringPayment: '32.90',
      slug: 'lite_v8',
      uniqueCommission: true,
    },
    {
      planId: '4ebaab20-8b93-4c7c-9035-8c61dc61866d',
      billings: [
        {
          amount: '117.90',
          planBillingId: '67b021a9-2992-4295-829a-f40e9a134f80',
          planId: '4ebaab20-8b93-4c7c-9035-8c61dc61866d',
          periodicity: 1,
          recurringPayment: '117.90',
          slug: 'basic_v8',
          discount: {
            percentage: '15% OFF*',
            originalValue: '139,00',
            subText: '*desconto válido no 1º mês',
          },
        },
        {
          amount: '582.00',
          planBillingId: '015299b1-6a92-414c-8336-d85b4b464472',
          planId: '4ebaab20-8b93-4c7c-9035-8c61dc61866d',
          periodicity: 6,
          recurringPayment: '97.00',
          slug: 'basic_v8',
          discount: { percentage: '30% OFF', originalValue: '834,00', subText: null },
        },
        {
          amount: '827.90',
          planBillingId: '9d5afca4-c724-4c79-a2e2-5f48fc68877a',
          planId: '4ebaab20-8b93-4c7c-9035-8c61dc61866d',
          periodicity: 12,
          recurringPayment: '68.99',
          slug: 'basic_v8',
          discount: { percentage: '50% OFF', originalValue: '1668,00', subText: null },
        },
      ],
      catalogLimit: 60,
      commission: 22,
      hasCollect: true,
      name: 'basic',
      recurringPayment: '117.90',
      slug: 'basic_v8',
      uniqueCommission: true,
    },
    {
      planId: '7686d53a-2d4c-47ac-bac5-aa97a22c44ae',
      billings: [
        {
          amount: '295.90',
          planBillingId: '51b9f0b3-84cc-4050-8e2d-2805dac65ae2',
          planId: '7686d53a-2d4c-47ac-bac5-aa97a22c44ae',
          periodicity: 1,
          recurringPayment: '295.90',
          slug: 'pro_v8',
          discount: {
            percentage: '15% OFF*',
            originalValue: '349,00',
            subText: '*desconto válido no 1º mês',
          },
        },
        {
          amount: '2087.90',
          planBillingId: 'd27bcf40-9393-482e-b3a9-a30a26db09ed',
          planId: '7686d53a-2d4c-47ac-bac5-aa97a22c44ae',
          periodicity: 12,
          recurringPayment: '173.99',
          slug: 'pro_v8',
          discount: { percentage: '50% OFF', originalValue: '4188,00', subText: null },
        },
        {
          amount: '1464.00',
          planBillingId: '63519170-57ce-4f9c-aee7-fa514b229de4',
          planId: '7686d53a-2d4c-47ac-bac5-aa97a22c44ae',
          periodicity: 6,
          recurringPayment: '244.00',
          slug: 'pro_v8',
          discount: { percentage: '30% OFF', originalValue: '2094,00', subText: null },
        },
      ],
      catalogLimit: 0,
      commission: 21,
      hasCollect: true,
      name: 'pro',
      recurringPayment: '295.90',
      slug: 'pro_v8',
      uniqueCommission: true,
    },
  ],
  hasPersonalData: true,
  features: [
    {
      label: 'cadastro de produtos',
      type: 'string',
      values: { lite: 'até 30 produtos', basic: 'até 60 produtos', pro: 'ilimitado' },
    },
    {
      label: 'anúncios pré-configurados',
      type: 'boolean',
      values: { lite: true, basic: true, pro: true },
    },
    {
      label: 'curadoria de catálogo e otimização de anúncios',
      type: 'boolean',
      values: { lite: true, basic: true, pro: true },
    },
    {
      label: 'ferramenta de análise de competitividade',
      type: 'boolean',
      values: { lite: true, basic: true, pro: true },
    },
    {
      label: 'painel de campanhas',
      type: 'boolean',
      values: { lite: true, basic: true, pro: true },
    },
    {
      label: 'participação em campanhas promocionais nos marketplaces',
      type: 'boolean',
      values: { lite: true, basic: true, pro: true },
    },
    {
      label: 'conciliação financeira dos canais de vendas',
      type: 'boolean',
      values: { lite: true, basic: true, pro: true },
    },
    {
      label: 'coleta de pedidos*',
      type: 'boolean',
      values: { lite: false, basic: true, pro: true },
    },
  ],
  faqQuestions: [
    {
      question: 'quais vantagens de vender com o <b>Olist Store</b>?',
      response:
        '<p><b>Mais vendas, menos trabalho.</b> \n    Parece uma combinação impossível, mas essa é a realidade de quem vende com o <b>olist</b>. \n    Por meio da nossa tecnologia, lojistas de todos os tamanhos podem melhorar a sua \n    performance nas vendas online com profissionalismo e escalabilidade.</p>\n    <p><b>Está começando a vender na internet?</b> Com o <b>olist</b> \n    você pode vender nos maiores marketplaces de uma só vez, \n    concentrando a gestão logística e de vendas em nossa plataforma. \n    Serviços financeiros, ferramentas exclusivas e times especializados à revisão de anúncios \n    e atendimento ao consumidor final também estão inclusos no pacote.&nbsp;</p>\n    <p>Para quem está começando a vender online, \n    o <b>olist</b> é a solução mais prática para ganhar robustez e expandir a operação.</p>\n    <p><b>Já vende online e quer crescer?</b> Nossas lojas dentro dos marketplaces estão \n    entre as mais procuradas pelos consumidores devido à nossa alta reputação. \n    Ao vender os seus produtos conosco você tem acesso à essa reputação, \n    o que gera mais visibilidade para os anúncios e mais chances de vendas.</p>\n    <p>Se você busca uma solução para aumentar o marketshare, \n    trazer novos clientes e crescer o faturamento, o <b>olist</b> é o canal perfeito para você.</p>',
    },
    {
      question: 'como funciona a cobrança da comissão e da mensalidade?',
      response:
        '<p>A comissão do <b>olist store</b>, assim como a de outros canais de vendas, \n    incide sobre o valor do produto vendido, sem adicionar o valor do frete. </p>\n    <p>A cobrança das comissões será feita automaticamente, assim como a mensalidade. \n    Os descontos são efetuados nos repasses enviados para a sua loja a cada ciclo de pagamento. \n    Assim, você já recebe o valor integral ao qual tem direito, sem precisar pagar mais nada ao <b>olist</b>. \n    As cobranças serão devidamente identificadas no extrato financeiro da sua loja. </p>\n    <p>\n       <a \n       href="https://ajuda.olist.com/hc/pt-br/articles/4409162517524-Como-funcionam-as-regras-de-comiss%C3%A3o-e-frete-do-Olist-Store-" \n       target="_blank" rel="noopener">\n       Veja o cálculo da cobrança de comissão do olist store neste artigo.\n       </a>\n    </p>\n    ',
    },
    {
      question: 'como funciona a cobrança do frete no <b>olist store?</b>',
      response:
        '<p>Existem dois cenários: os produtos com valor abaixo de R$ 79,00 e os acima ou igual a R$ 79,00.</p>\n    <p>&nbsp;</p>\n    <p>Nos produtos abaixo de R$ 79,00 quem paga o valor do frete é o consumidor. O lojista só paga a taxa fixa de R$\n        5 por item vendido. Então, se você vender mais de um item por pedido, é cobrado R$ 5 por cada um.</p>\n    <p>&nbsp;</p>\n    <p>Montar kits de produtos é uma excelente opção para evitar a cobrança da taxa fixa por item e ainda aumentar o seu\n        ticket médio. <a href="https://ajuda.olist.com/hc/pt-br/articles/4409162634644-Como-e-quando-criar-kits-de-produtos"\n        target="_blank" rel="noopener">Veja como montar kits neste artigo.</a></p>\n    <p>&nbsp;</p>\n    <p>Nos pedidos acima ou igual a R$ 79,00 não há cobrança da taxa de R$ 5 por item, por isso independe o número de\n        produtos no pacote. Contudo, neste cenário, o frete é grátis para o consumidor e quem paga o valor é o lojista\n        em coparticipação com o <b>olist</b>.</p>\n    <p>&nbsp;</p>\n    <p>\n    <a \n    href="https://ajuda.olist.com/hc/pt-br/articles/4409162919700-Tabela-de-frete-Olist-seus-produtos-muito-mais-competitivos-e-atrativos-para-o-consumidor"\n    target="_blank" rel="noopener">\n    Neste artigo você confere a tabela de frete exclusiva do olist, \n    com preços competitivos para impulsionar as suas vendas.\n    </a></p>',
    },
    {
      question: 'se eu vender mais de um item por pedido, como será o cálculo do meu frete?',
      response:
        '<p>Existem dois cenários: os produtos com valor abaixo de R$ 79,00 e os acima ou igual a R$ 79,00.</p>\n    <p>&nbsp;</p>\n    <p>Nos produtos abaixo de R$ 79,00 quem paga o valor do frete é o consumidor. Contudo, o lojista paga a taxa fixa\n        de R$ 5 por item vendido. Então, se você vender mais de um item por pedido, é cobrado R$ 5 por cada um.</p>\n    <p>&nbsp;</p>\n    <p>Montar kits de produtos é uma excelente opção para evitar a cobrança da taxa fixa por item e ainda aumentar o seu\n        ticket médio. <a href="https://ajuda.olist.com/hc/pt-br/articles/4409162634644-Como-e-quando-criar-kits-de-produtos"\n        target="_blank" rel="noopener">Veja como montar kits neste artigo</a>.</p>\n    <p>&nbsp;</p>\n    <p>Já nos pedidos acima de R$ 79,00 não há cobrança da taxa de R$ 5 por item, \n    por isso independe o número de produtos\n        no pacote.</p>\n    <p>&nbsp;</p>\n    <p>Contudo, se o consumidor final comprar produtos diferentes do mesmo lojista (uma caneta, um caderno e um estojo,\n        por exemplo), será cobrado o valor do frete de cada produto.</p>\n    <p>&nbsp;</p>\n    <p>Lembrando que, neste cenário, \n    o frete é grátis para o consumidor e quem paga o valor é o lojista em coparticipação\n        com o <b>olist</b>.</p>\n    <p>&nbsp;</p>\n    <p>\n    <a \n    href="https://ajuda.olist.com/hc/pt-br/articles/4409162919700-Tabela-de-frete-Olist-seus-produtos-muito-mais-competitivos-e-atrativos-para-o-consumidor"\n        target="_blank" \n        rel="noopener">Neste artigo você confere a tabela de frete exclusiva do olist, \n        com preços competitivos para impulsionar as suas vendas.\n        </a></p>',
    },
    {
      question:
        'em casos de frete grátis, \n    a cidade ou estado para qual o pedido será enviado influencia no valor do frete?',
      response:
        '<p>Não. A tabela de frete é baseada na região em que o lojista está e também no peso do produto. \n    Dessa forma, se o\n    consumidor for da região norte e o pedido for expedido da região sudeste, o lojista pagará o valor de frete\n    tabelado para a região sudeste.</p>\n    <p>&nbsp;</p>\n    <p>Lembrando que o <b>olist</b> coparticipa no pagamento do frete.</p>\n    <p>&nbsp;</p>\n    <p><a href="https://ajuda.olist.com/hc/pt-br/articles/4409162919700-Tabela-de-frete-Olist-seus-produtos-muito-mais-competitivos-e-atrativos-para-o-consumidor"\n    target="_blank" rel="noopener">Confira aqui a tabela de frete exclusiva do olist, \n    com preços competitivos para impulsionar as suas vendas.</a></p>',
    },
    {
      question: 'em caso de devolução do pedido, como será cobrado o frete?',
      response:
        '<p>Em caso de devolução do pedido por parte do consumidor, \n    quem arca com o custo do frete é o lojista, tanto nos produtos\n    abaixo de R$ 79,00 quanto naqueles com valor igual ou superior.</p>\n    <p>&nbsp;</p>\n    <p>*O custo do frete em caso de devolução é tabelado pelos Correios. \n    Para mais informações, acesse o site da instituição.</p>',
    },
    {
      question: 'a comissão do <b>olist</b> já inclui a comissão dos marketplaces?',
      response:
        '<p>sim! A comissão do <b>olist</b> já engloba as taxas cobradas pelos marketplaces parceiros. \n    Dessa forma, você não precisa arcar com nenhum outro tipo de tarifa externa.</p>',
    },
    {
      question: 'quais são os requisitos para vender com o olist store?',
      response:
        '<p>um dos requisitos para vender com o olist é emitir \n    Nota Fiscal Eletrônica (NF-e) em formato XML e com chave de\n    acesso digital. Então se você é MEI (Microempreendedor Individual) pode vender com o olist desde que emita\n    NF-e. Além disso, aceitamos somente lojas que trabalham com as categorias regulamentadas pelos canais de venda\n    parceiros.</p>\n    <p>&nbsp;</p>\n    <p>NÃO comercializamos serviços, itens de moda/vestuário e produtos usados, por exemplo.</p>\n    <p><a href="https://olist.com/produtos-proibidos/">Confira aqui a lista completa de produtos proibidos.</a></p>',
    },
    {
      question: 'em quais marketplaces o <b>olist</b> está presente?',
      response:
        '<p>o <b>olist</b> está presente em mais de 10 marketplaces diferentes. Confira a lista completa dos sites\n    parceiros: Amazon, Americanas.com, Carrefour, Casas Bahia, Extra.com, MadeiraMadeira, Mercado Livre, Ponto\n    Frio, Shoptime, Submarino, Zoom.</p>',
    },
    {
      question: 'quais são as integrações do <b>olist store</b>?',
      response:
        '<p>pensando em facilitar a gestão das vendas de nossos lojistas, \n    o olist está integrado a diversos ERPs, plataformas\n    de e-commerce e hubs. A nossa lista de parceiros inclui as seguintes empresas: \n    Bling, Tray, VHSYS, Tiny, BizCommerce,\n    iSET, F1 Commerce, BSeller. O <b>olist</b> também tem integração exclusiva com a transportadora privada\n    Jadlog, o que permite uma melhor performance das entregas e custos de frete reduzidos.</p>\n    <p>&nbsp;</p>\n    <p><a href="https://olist.com/parceiros/">Saiba mais sobre as integrações do <b>olist</b>.</a></p>',
    },
    {
      question: 'como funciona o serviço de coleta de <b>olist store</b>?',
      response:
        '<p>Ao contratar o plano pro, o envio de todas as vendas processadas em <b>olist store</b> serão coletadas\n    diariamente pelo time <b>olist-PAX</b> no endereço informado no cadastro, em no máximo 24h. Assim\n    você ganha mais praticidade na operação e prazos de entrega 70% menores, alavancando a conversão dos seus anúncios\n    nos canais de venda.</p>\n    <p>O serviço de coleta <b>olist-PAX</b> atende:</p>\n    <p>Capitais e região metropolitana:</p>\n    <ul>\n        <li>São Paulo</li>\n        <li>Rio de Janeiro</li>\n        <li>Belo Horizonte</li>\n        <li>Curitiba</li>\n        <li>Porto Alegre</li>\n    </ul>\n    <p>Demais cidades:</p>\n    <ul>\n        <li>Campinas</li>\n        <li>Sorocaba</li>\n        <li>São José dos Campos</li>\n        <li>Ibitinga</li>\n    </ul>\n    <p>Próximas regiões:</p>\n    <ul>\n        <li>Vitória</li>\n        <li>Salvador</li>\n        <li>Recife</li>\n        <li>Florianópolis</li>\n        <li>Brasília</li>\n        <li>Vale do Itajaí</li>\n    </ul>\n    <p data-pm-slice="1 1 []">*Avaliaremos a disponibilidade da coleta de acordo com seu CEP</p>\n    <p>*Demais regiões são atendidas pelos Correios e transportadoras parceiras de <b>olist store</b>.</p>\n    <p>&nbsp;</p>',
    },
    {
      question: 'quais as vantagens de enviar o pedido em 24 horas?',
      response:
        '<p>No e-commerce, o prazo de entrega de um produto pode ser o seu maior aliado ou o seu pior detrator. \n    Isso porque\n    quanto menor o tempo de entrega, \n    maiores são as chances do cliente escolher o seu produto e não o do concorrente.</p>\n    <p>&nbsp;</p>\n    <p>Estudos de mercado apontam que a demora na entrega é a responsável pela desistência de \n    55% a 77% das compras online.\n        Já os produtos com envio em menos de 24 horas têm um aumento médio de 48% na taxa de conversão. Ou seja, 48%\n        mais vendas.</p>\n    <p>&nbsp;</p>\n    <p>Para que os lojistas de <b>olist store</b> gerem ainda mais pedidos em seus anúncios, orientamos que\n        o tempo de operação da venda – \n        entre recebimento do pedido na plataforma e postagem nos Correios ou transportadoras\n        – <b>seja de 24 horas em dias úteis.</b>&nbsp;</p>\n    <p>&nbsp;</p>\n    <p>Imprimir essa agilidade na operação aumenta a \n    sua taxa de conversão e garante giro de estoque e liquidez de vendas\n        constantes.</p>\n    <p>&nbsp;</p>\n    <p><em>Para apoiar o seu negócio nesta etapa e otimizar \n    seu prazo de entrega, conte com o serviço de coleta de <b>olist store</b>, \n    disponível no plano basic, pro e premium.</em></p>',
    },
  ],
  notes: ['*serviço de coleta de pedidos sujeito à análise.'],
  plansNames: { lite_v8: 'lite', basic_v8: 'basic', pro_v8: 'pro' },
};

export const PLAN_OPTIONS_MOCK = {
  title: '<h1>Mais tecnologia e competitividade para sua loja crescer em marketplaces</h1>',
  description:
    '<p>Saia na frente e aproveite as maiores oportunidades dos canais de venda&nbsp;</p>',
  resources_title: '<h2>Principais recursos</h2>',
  resources_description:
    '<p>Explore as funcionalidades de <strong>olist store</strong> e descubra como elas te ajudam a crescer nos canais de venda</p>',
  testimony_title: '<h2>Você no topo – e sem dor de cabeça</h2>',
  requirements_title: '<h2>Requisitos para vender com o Olist</h2>',
  requirements_helper:
    '<div class="raw-html-embed">Não atende a todos os requisitos acima, mas ainda assim quer vender em marketplaces com as soluções do Olist? <a target="_blank" href="https://ajuda.olist.com/hc/pt-br/articles/4409254432148-N%C3%A3o-possui-todos-os-requisitos-para-criar-conta-no-Olist-Store-Veja-como-podemos-te-ajudar">Descubra como podemos te ajudar.</a>\n</div>',
  faq_title: '<h2>Ainda tem dúvidas? Encontre as respostas</h2>',
  createdAt: '2023-09-12T18:09:05.173Z',
  updatedAt: '2023-10-10T17:45:44.014Z',
  locale: 'pt-BR',
  modal_cost_title: '<p>Custo final por venda</p>',
  main_resources_title: '<p>O que só o Olist oferece:</p>',
  modal_title: 'Entenda como funciona',
  partners_images: {
    data: [
      {
        id: 9736,
        attributes: {
          name: 'Logo-banco-inter.png',
          alternativeText: null,
          caption: null,
          width: 150,
          height: 56,
          formats: {
            xsmall: {
              ext: '.png',
              url: 'https://d3hw41hpah8tvx.cloudfront.net/images/xsmall_Logo_banco_inter_7a191ea1fa.png',
              hash: 'xsmall_Logo_banco_inter_7a191ea1fa',
              mime: 'image/png',
              name: 'xsmall_Logo-banco-inter.png',
              path: null,
              size: 1.72,
              width: 64,
              height: 24,
            },
          },
          hash: 'Logo_banco_inter_7a191ea1fa',
          ext: '.png',
          mime: 'image/png',
          size: 1.01,
          url: 'https://d3hw41hpah8tvx.cloudfront.net/images/Logo_banco_inter_7a191ea1fa.png',
          previewUrl: null,
          provider: '@strapi/provider-upload-custom-cloudfront-s3',
          provider_metadata: null,
          createdAt: '2023-10-10T17:04:28.978Z',
          updatedAt: '2023-10-10T17:04:28.978Z',
        },
      },
      {
        id: 9735,
        attributes: {
          name: 'carrefour-logo.png',
          alternativeText: null,
          caption: null,
          width: 150,
          height: 29,
          formats: {
            xsmall: {
              ext: '.png',
              url: 'https://d3hw41hpah8tvx.cloudfront.net/images/xsmall_carrefour_logo_c94ad8138c.png',
              hash: 'xsmall_carrefour_logo_c94ad8138c',
              mime: 'image/png',
              name: 'xsmall_carrefour-logo.png',
              path: null,
              size: 1.59,
              width: 64,
              height: 12,
            },
          },
          hash: 'carrefour_logo_c94ad8138c',
          ext: '.png',
          mime: 'image/png',
          size: 1.3,
          url: 'https://d3hw41hpah8tvx.cloudfront.net/images/carrefour_logo_c94ad8138c.png',
          previewUrl: null,
          provider: '@strapi/provider-upload-custom-cloudfront-s3',
          provider_metadata: null,
          createdAt: '2023-10-10T17:03:57.370Z',
          updatedAt: '2023-10-10T17:03:57.370Z',
        },
      },
      {
        id: 9700,
        attributes: {
          name: 'logomarketplaces-americanas.png',
          alternativeText: 'lojas americanas',
          caption: null,
          width: 102,
          height: 29,
          formats: {
            xsmall: {
              ext: '.png',
              url: 'https://d3hw41hpah8tvx.cloudfront.net/images/xsmall_logomarketplaces_americanas_dfbc1ddafe.png',
              hash: 'xsmall_logomarketplaces_americanas_dfbc1ddafe',
              mime: 'image/png',
              name: 'xsmall_logomarketplaces-americanas.png',
              path: null,
              size: 1.7,
              width: 64,
              height: 18,
            },
          },
          hash: 'logomarketplaces_americanas_dfbc1ddafe',
          ext: '.png',
          mime: 'image/png',
          size: 0.58,
          url: 'https://d3hw41hpah8tvx.cloudfront.net/images/logomarketplaces_americanas_dfbc1ddafe.png',
          previewUrl: null,
          provider: '@strapi/provider-upload-custom-cloudfront-s3',
          provider_metadata: null,
          createdAt: '2023-09-12T18:08:56.697Z',
          updatedAt: '2023-09-28T14:48:03.143Z',
        },
      },
      {
        id: 9703,
        attributes: {
          name: 'logomarketplaces-shoptime.png',
          alternativeText: 'shoptime',
          caption: null,
          width: 90,
          height: 24,
          formats: {
            xsmall: {
              ext: '.png',
              url: 'https://d3hw41hpah8tvx.cloudfront.net/images/xsmall_logomarketplaces_shoptime_3831aa500a.png',
              hash: 'xsmall_logomarketplaces_shoptime_3831aa500a',
              mime: 'image/png',
              name: 'xsmall_logomarketplaces-shoptime.png',
              path: null,
              size: 1.73,
              width: 64,
              height: 17,
            },
          },
          hash: 'logomarketplaces_shoptime_3831aa500a',
          ext: '.png',
          mime: 'image/png',
          size: 0.63,
          url: 'https://d3hw41hpah8tvx.cloudfront.net/images/logomarketplaces_shoptime_3831aa500a.png',
          previewUrl: null,
          provider: '@strapi/provider-upload-custom-cloudfront-s3',
          provider_metadata: null,
          createdAt: '2023-09-12T18:08:58.731Z',
          updatedAt: '2023-09-28T14:48:37.647Z',
        },
      },
      {
        id: 9704,
        attributes: {
          name: 'logomarketplaces-madeiramadeira.png',
          alternativeText: 'madeira madeira',
          caption: null,
          width: 125,
          height: 24,
          formats: {
            xsmall: {
              ext: '.png',
              url: 'https://d3hw41hpah8tvx.cloudfront.net/images/xsmall_logomarketplaces_madeiramadeira_eede89a308.png',
              hash: 'xsmall_logomarketplaces_madeiramadeira_eede89a308',
              mime: 'image/png',
              name: 'xsmall_logomarketplaces-madeiramadeira.png',
              path: null,
              size: 1.25,
              width: 64,
              height: 12,
            },
          },
          hash: 'logomarketplaces_madeiramadeira_eede89a308',
          ext: '.png',
          mime: 'image/png',
          size: 0.83,
          url: 'https://d3hw41hpah8tvx.cloudfront.net/images/logomarketplaces_madeiramadeira_eede89a308.png',
          previewUrl: null,
          provider: '@strapi/provider-upload-custom-cloudfront-s3',
          provider_metadata: null,
          createdAt: '2023-09-12T18:08:58.732Z',
          updatedAt: '2023-09-28T14:48:47.259Z',
        },
      },
      {
        id: 9705,
        attributes: {
          name: 'logomarketplaces-ponto.png',
          alternativeText: 'ponto frio',
          caption: null,
          width: 70,
          height: 24,
          formats: {
            xsmall: {
              ext: '.png',
              url: 'https://d3hw41hpah8tvx.cloudfront.net/images/xsmall_logomarketplaces_ponto_9d59571bd2.png',
              hash: 'xsmall_logomarketplaces_ponto_9d59571bd2',
              mime: 'image/png',
              name: 'xsmall_logomarketplaces-ponto.png',
              path: null,
              size: 1.24,
              width: 64,
              height: 22,
            },
          },
          hash: 'logomarketplaces_ponto_9d59571bd2',
          ext: '.png',
          mime: 'image/png',
          size: 0.56,
          url: 'https://d3hw41hpah8tvx.cloudfront.net/images/logomarketplaces_ponto_9d59571bd2.png',
          previewUrl: null,
          provider: '@strapi/provider-upload-custom-cloudfront-s3',
          provider_metadata: null,
          createdAt: '2023-09-12T18:08:58.825Z',
          updatedAt: '2023-09-28T14:48:56.754Z',
        },
      },
      {
        id: 9706,
        attributes: {
          name: 'logomarketplaces-casasbahia.png',
          alternativeText: 'casas bahia',
          caption: null,
          width: 124,
          height: 29,
          formats: {
            xsmall: {
              ext: '.png',
              url: 'https://d3hw41hpah8tvx.cloudfront.net/images/xsmall_logomarketplaces_casasbahia_6383b963b0.png',
              hash: 'xsmall_logomarketplaces_casasbahia_6383b963b0',
              mime: 'image/png',
              name: 'xsmall_logomarketplaces-casasbahia.png',
              path: null,
              size: 1.51,
              width: 64,
              height: 15,
            },
          },
          hash: 'logomarketplaces_casasbahia_6383b963b0',
          ext: '.png',
          mime: 'image/png',
          size: 0.77,
          url: 'https://d3hw41hpah8tvx.cloudfront.net/images/logomarketplaces_casasbahia_6383b963b0.png',
          previewUrl: null,
          provider: '@strapi/provider-upload-custom-cloudfront-s3',
          provider_metadata: null,
          createdAt: '2023-09-12T18:08:59.326Z',
          updatedAt: '2023-09-28T14:49:03.558Z',
        },
      },
      {
        id: 9707,
        attributes: {
          name: 'logomarketplaces-mercadolivre.png',
          alternativeText: 'mercado livre',
          caption: null,
          width: 81,
          height: 29,
          formats: {
            xsmall: {
              ext: '.png',
              url: 'https://d3hw41hpah8tvx.cloudfront.net/images/xsmall_logomarketplaces_mercadolivre_46a3254cdf.png',
              hash: 'xsmall_logomarketplaces_mercadolivre_46a3254cdf',
              mime: 'image/png',
              name: 'xsmall_logomarketplaces-mercadolivre.png',
              path: null,
              size: 2.51,
              width: 64,
              height: 23,
            },
          },
          hash: 'logomarketplaces_mercadolivre_46a3254cdf',
          ext: '.png',
          mime: 'image/png',
          size: 1.08,
          url: 'https://d3hw41hpah8tvx.cloudfront.net/images/logomarketplaces_mercadolivre_46a3254cdf.png',
          previewUrl: null,
          provider: '@strapi/provider-upload-custom-cloudfront-s3',
          provider_metadata: null,
          createdAt: '2023-09-12T18:08:59.330Z',
          updatedAt: '2023-09-28T14:49:10.777Z',
        },
      },
      {
        id: 9708,
        attributes: {
          name: 'logomarketplaces-submarino.png',
          alternativeText: 'submarino',
          caption: null,
          width: 110,
          height: 24,
          formats: {
            xsmall: {
              ext: '.png',
              url: 'https://d3hw41hpah8tvx.cloudfront.net/images/xsmall_logomarketplaces_submarino_8cc3f1f81a.png',
              hash: 'xsmall_logomarketplaces_submarino_8cc3f1f81a',
              mime: 'image/png',
              name: 'xsmall_logomarketplaces-submarino.png',
              path: null,
              size: 1.05,
              width: 64,
              height: 14,
            },
          },
          hash: 'logomarketplaces_submarino_8cc3f1f81a',
          ext: '.png',
          mime: 'image/png',
          size: 0.56,
          url: 'https://d3hw41hpah8tvx.cloudfront.net/images/logomarketplaces_submarino_8cc3f1f81a.png',
          previewUrl: null,
          provider: '@strapi/provider-upload-custom-cloudfront-s3',
          provider_metadata: null,
          createdAt: '2023-09-12T18:08:59.334Z',
          updatedAt: '2023-09-28T14:49:20.859Z',
        },
      },
      {
        id: 9709,
        attributes: {
          name: 'logomarketplaces-magazineluiza.png',
          alternativeText: 'magalu',
          caption: null,
          width: 74,
          height: 29,
          formats: {
            xsmall: {
              ext: '.png',
              url: 'https://d3hw41hpah8tvx.cloudfront.net/images/xsmall_logomarketplaces_magazineluiza_2b76ecddc2.png',
              hash: 'xsmall_logomarketplaces_magazineluiza_2b76ecddc2',
              mime: 'image/png',
              name: 'xsmall_logomarketplaces-magazineluiza.png',
              path: null,
              size: 1.82,
              width: 64,
              height: 25,
            },
          },
          hash: 'logomarketplaces_magazineluiza_2b76ecddc2',
          ext: '.png',
          mime: 'image/png',
          size: 0.48,
          url: 'https://d3hw41hpah8tvx.cloudfront.net/images/logomarketplaces_magazineluiza_2b76ecddc2.png',
          previewUrl: null,
          provider: '@strapi/provider-upload-custom-cloudfront-s3',
          provider_metadata: null,
          createdAt: '2023-09-12T18:08:59.428Z',
          updatedAt: '2023-09-28T14:49:27.453Z',
        },
      },
      {
        id: 9710,
        attributes: {
          name: 'logomarketplaces-amazon.png',
          alternativeText: 'amazon',
          caption: null,
          width: 66,
          height: 29,
          formats: {
            xsmall: {
              ext: '.png',
              url: 'https://d3hw41hpah8tvx.cloudfront.net/images/xsmall_logomarketplaces_amazon_19daec566c.png',
              hash: 'xsmall_logomarketplaces_amazon_19daec566c',
              mime: 'image/png',
              name: 'xsmall_logomarketplaces-amazon.png',
              path: null,
              size: 1.66,
              width: 64,
              height: 28,
            },
          },
          hash: 'logomarketplaces_amazon_19daec566c',
          ext: '.png',
          mime: 'image/png',
          size: 0.58,
          url: 'https://d3hw41hpah8tvx.cloudfront.net/images/logomarketplaces_amazon_19daec566c.png',
          previewUrl: null,
          provider: '@strapi/provider-upload-custom-cloudfront-s3',
          provider_metadata: null,
          createdAt: '2023-09-12T18:08:59.636Z',
          updatedAt: '2023-09-28T14:49:34.467Z',
        },
      },
      {
        id: 9733,
        attributes: {
          name: 'ali.png',
          alternativeText: null,
          caption: null,
          width: 306,
          height: 71,
          formats: {
            xsmall: {
              ext: '.png',
              url: 'https://d3hw41hpah8tvx.cloudfront.net/images/xsmall_ali_bae6d00b20.png',
              hash: 'xsmall_ali_bae6d00b20',
              mime: 'image/png',
              name: 'xsmall_ali.png',
              path: null,
              size: 2.03,
              width: 64,
              height: 15,
            },
            thumbnail: {
              ext: '.png',
              url: 'https://d3hw41hpah8tvx.cloudfront.net/images/thumbnail_ali_bae6d00b20.png',
              hash: 'thumbnail_ali_bae6d00b20',
              mime: 'image/png',
              name: 'thumbnail_ali.png',
              path: null,
              size: 10.48,
              width: 245,
              height: 57,
            },
          },
          hash: 'ali_bae6d00b20',
          ext: '.png',
          mime: 'image/png',
          size: 2.25,
          url: 'https://d3hw41hpah8tvx.cloudfront.net/images/ali_bae6d00b20.png',
          previewUrl: null,
          provider: '@strapi/provider-upload-custom-cloudfront-s3',
          provider_metadata: null,
          createdAt: '2023-10-10T15:36:46.266Z',
          updatedAt: '2023-10-10T15:36:46.266Z',
        },
      },
    ],
  },
  resources: [
    {
      id: 1,
      title: '<p>Mais <strong>exposição online</strong></p>',
      resources_items: [
        {
          id: 2,
          title: '<p>Alta reputação</p>',
          description:
            '<p>Venda como a Loja Oficial do <strong>Olist</strong> e ganhe a confiança do público</p>',
          featured: false,
        },
        {
          id: 1,
          title: '<p>Gestão unificada</p>',
          description:
            '<p>Diversifique seus canais de vendas sem perder tempo com a gestão de cada um separadamente</p>',
          featured: false,
        },
        {
          id: 3,
          title: '<p>Promoções e campanhas</p>',
          description:
            '<p>Participe de campanhas comerciais exclusivas nos marketplaces e aumente suas vendas</p>',
          featured: true,
        },
      ],
    },
    {
      id: 2,
      title: '<p>Mais <strong>inteligência de mercado</strong></p>',
      resources_items: [
        {
          id: 4,
          title: '<p>Precificação descomplicada</p>',
          description:
            '<p>Garanta o preço ideal para os produtos com nossa ferramenta de precificação, que analisa tendências da concorrência para você</p>',
          featured: false,
        },
        {
          id: 5,
          title: '<p>Anúncios otimizados para alta conversão</p>',
          description:
            '<p>Gere mais vendas com anúncios otimizados pela nossa inteligência artificial (AI)</p>',
          featured: false,
        },
        {
          id: 6,
          title: '<p>Incentivo Olist</p>',
          description:
            '<p>Aproveite o subsídio do Olist para vender seus produtos com preço mais competitivo e aumentar suas vendas</p>',
          featured: true,
        },
      ],
    },
    {
      id: 3,
      title: '<p>Mais <strong>agilidade operacional</strong></p>',
      resources_items: [
        {
          id: 7,
          title: '<p>Atendimento ao consumidor</p>',
          description: '<p>Deixe conosco as tratativas de pós-venda aos clientes da sua loja</p>',
          featured: true,
        },
        {
          id: 8,
          title: '<p>Logística de ponta</p>',
          description: '<p>Use a seu favor a tabela de frete do Olist com até 50% de desconto</p>',
          featured: false,
        },
        {
          id: 9,
          title: '<p>Coleta de produtos</p>',
          description:
            '<p>Economize tempo com nossa coleta unificada de múltiplos marketplaces (disponível em 140 cidades)</p>',
          featured: false,
        },
      ],
    },
    {
      id: 4,
      title: '<p>Mais <strong>eficiência financeira</strong></p>',
      resources_items: [
        {
          id: 12,
          title: '<p>Comissão competitiva</p>',
          description:
            '<p>Venda em múltiplos canais com uma única comissão, sem se preocupar com taxas distintas</p>',
          featured: false,
        },
        {
          id: 11,
          title: '<p>Relatórios de performance</p>',
          description: '<p>Acesse facilmente os principais indicadores do seu negócio</p>',
          featured: false,
        },
        {
          id: 10,
          title: '<p>Saque flexível</p>',
          description:
            '<p>Tenha a possibilidade de antecipar repasses no <strong>Olist</strong> com as melhores taxas do mercado</p>',
          featured: true,
        },
      ],
    },
  ],
  testimony_banner: {
    id: 4,
    title:
      '“olist store eliminou a dor de cabeça de vender em outros marketplaces. A clareza dos dados através das APIs, a assessoria do time trazendo insights do mercado e os relatórios de repasse, por exemplo, são muito importantes para nós. Tudo isso contribui para acelerar nosso crescimento.”',
    button_title: 'faça parte',
    button_link: null,
    description: '<p><strong>Cláudio Vidal</strong></p><p>da Xcomm</p>',
  },
  requirements_faq: [
    {
      id: 22,
      question: '<p>Ter cnpj</p>',
      answer: '<p>Todos os tipos de empresa são aceitas, do MEI à Sociedade Limitada.</p>',
    },
    {
      id: 24,
      question: '<p>Ter conta bancária PJ</p>',
      answer:
        '<p>Para garantir a segurança no repasse, os valores são depositados em uma conta bancária vinculada ao CNPJ cadastrado.</p>',
    },
    {
      id: 25,
      question: '<p>Emitir Nota Fiscal</p>',
      answer: '<p>O tipo da nota é a NF-e XML, utilizada na compra e venda online de produtos</p>',
    },
    {
      id: 23,
      question: '<p>Ter código de barras</p>',
      answer:
        '<p>O código de barras do produto é um requisito dos marketplaces para publicação de novos anúncios.</p><p>&nbsp;</p><p>Caso você não possua código de barras GTIN/EAN dos produtos, deverá solicitá-los à <a href="https://www.gs1br.org/">GS1 Brasil</a> – empresa responsável pela emissão e regulação desse serviço no país.</p>',
    },
    {
      id: 26,
      question: '<p>Atuar nas categorias aceitas</p>',
      answer:
        '<p>Eletroportáteis, eletrônicos, automotivo, alimentos e bebidas, brinquedos e games, utilidades domésticas, móveis, casa e decoração, informática, celulares, esporte, cama, mesa e banho, pet shop, perfumaria. <a href="https://olist.com/pt-br/solucoes-para-comercio/vender-em-marketplaces/categorias-restritas/">Veja a lista completa e categorias proibidas</a></p>',
    },
    {
      id: 27,
      question: '<p>Atuar nas regiões cobertas</p>',
      answer:
        '<p>Atendemos empresas dos estados de&nbsp;<strong>SP</strong>, <strong>RJ</strong>, <strong>ES</strong>, <strong>MG</strong>, <strong>PR</strong>, <strong>SC</strong>, <strong>RS</strong> e <strong>BA</strong> e estamos trabalhando para cobrir outras regiões em breve.</p>',
    },
  ],
  requirements_image: {
    data: {
      id: 9711,
      attributes: {
        name: 'img_planosstore.png',
        alternativeText: 'oist app dashboard',
        caption: null,
        width: 512,
        height: 625,
        formats: {
          small: {
            ext: '.png',
            url: 'https://d3hw41hpah8tvx.cloudfront.net/images/small_img_planosstore_e459d84aa8.png',
            hash: 'small_img_planosstore_e459d84aa8',
            mime: 'image/png',
            name: 'small_img_planosstore.png',
            path: null,
            size: 111.41,
            width: 410,
            height: 500,
          },
          xsmall: {
            ext: '.png',
            url: 'https://d3hw41hpah8tvx.cloudfront.net/images/xsmall_img_planosstore_e459d84aa8.png',
            hash: 'xsmall_img_planosstore_e459d84aa8',
            mime: 'image/png',
            name: 'xsmall_img_planosstore.png',
            path: null,
            size: 4.66,
            width: 52,
            height: 64,
          },
          thumbnail: {
            ext: '.png',
            url: 'https://d3hw41hpah8tvx.cloudfront.net/images/thumbnail_img_planosstore_e459d84aa8.png',
            hash: 'thumbnail_img_planosstore_e459d84aa8',
            mime: 'image/png',
            name: 'thumbnail_img_planosstore.png',
            path: null,
            size: 15.98,
            width: 128,
            height: 156,
          },
        },
        hash: 'img_planosstore_e459d84aa8',
        ext: '.png',
        mime: 'image/png',
        size: 32.4,
        url: 'https://d3hw41hpah8tvx.cloudfront.net/images/img_planosstore_e459d84aa8.png',
        previewUrl: null,
        provider: '@strapi/provider-upload-custom-cloudfront-s3',
        provider_metadata: null,
        createdAt: '2023-09-13T12:28:46.329Z',
        updatedAt: '2023-09-28T14:50:01.544Z',
      },
    },
  },
  faqs: [
    {
      id: 28,
      question: '<p>Quais vantagens eu tenho no plano Crescer?</p>',
      answer:
        '<p>O plano Crescer é ideal para quem fatura até R$ 1 milhão por mês. Com ele, você tem:</p><p>&nbsp;</p><ul><li>Acesso a todas as funcionalidades da plataforma&nbsp;olist</li><li>Acesso ao&nbsp;<strong>Olist Class</strong> (aulas com conteúdos essenciais para vender com o Olist, fornecidas por nossos especialistas em e-commerce)</li></ul>',
    },
    {
      id: 29,
      question: '<p>Quais vantagens eu tenho no plano Evoluir?</p>',
      answer:
        '<p>O plano Evoluir é ideal para quem fatura entre R$ 1 milhão e R$ 3 milhões por mês. Com ele, você tem:</p><p>&nbsp;</p><ul><li>Acesso a todas as funcionalidades da plataforma&nbsp;olist</li><li>Comissão reduzida</li><li>Acesso ao&nbsp;<strong>Olist Class</strong> (aulas com conteúdos essenciais para vender com o Olist, fornecidas por nossos especialistas em e-commerce)</li><li>Implementação guiada e individual. Impulsione o início da sua jornada com um acompanhamento estratégico personalizado, oferecido por nossos especialistas em vendas online</li><li><strong>25% de desconto na contratação do Tiny</strong>, nosso sistema de gestão&nbsp;(condição válida para o plano Evoluir de Tiny)</li></ul>',
    },
    {
      id: 31,
      question: '<p>Quais vantagens eu tenho no plano Potencializar?</p>',
      answer:
        '<p>O plano Evoluir é ideal para quem fatura mais de R$ 3 milhões por mês. Com ele, você tem:</p><p>&nbsp;</p><ul><li>Acesso a todas as funcionalidades da plataforma olist</li><li>Comissão reduzida</li><li>Acesso ao <strong>Olist Class</strong> (aulas com conteúdos essenciais para vender com o Olist, fornecidas por nossos especialistas em e-commerce)</li><li>Implementação guiada e individual. Impulsione o início da sua jornada com um acompanhamento estratégico personalizado, oferecido por nossos especialistas em vendas online</li><li><strong>50% de desconto na contratação do Tiny</strong>, nosso sistema de gestão (condição válida para o plano Potencializar de Tiny)</li><li>Incentivos do Olist em campanhas dentro dos marketplaces para impulsionar suas vendas. Aplicado somente em negociações exclusivas que atendam critérios específicos de produtos, preço e estoque</li><li>Gerente de contas exclusivo (válido para os 6 primeiros meses e, caso haja boa performance, para os demais meses)</li></ul>',
    },
    {
      id: 30,
      question: '<p>Como funciona a cobrança da comissão e da mensalidade?</p>',
      answer:
        '<p>A comissão do Olist, assim como a de outros canais de vendas, incide sobre o valor do produto vendido, sem adicionar o valor do frete. A cobrança das comissões será feita automaticamente, assim como a mensalidade. Os descontos são efetuados nos repasses enviados para a sua loja a cada ciclo de pagamento. Assim, você já recebe o valor integral ao qual tem direito, sem precisar pagar mais nada ao Olist. As cobranças serão devidamente identificadas no extrato financeiro da sua loja. <a href="https://ajuda.olist.com/hc/pt-br/articles/4409162517524-Como-funcionam-as-regras-de-comiss%C3%A3o-e-frete-do-Olist-Store-">Veja o cálculo da cobrança de comissão do Olist neste artigo.</a></p>',
    },
    {
      id: 32,
      question: '<p>Como funciona a cobrança do frete no Olist?</p>',
      answer:
        '<p style="margin-left:0px;">Para produtos abaixo de R$ 79, o frete é pago integralmente pelo consumidor final. A tabela de frete do Olist é válida somente para produtos com valor igual ou acima de R$ 79 – que têm entrega grátis para o consumidor final. Nesse caso, o preço do frete varia de acordo com os seguintes fatores:</p><p style="margin-left:0px;">– Região de expedição<br>– Quantidade de produtos enviados<br>– Peso do produto, que pode ser o peso físico ou cúbico – <a href="https://ajuda.olist.com/hc/pt-br/articles/4409264907028-Como-calcular-o-peso-do-frete?_gl=1*j91rt1*_gcl_au*MTg0NzQ4NzE4Ny4xNjgxNzUzNTI4&amp;_ga=2.2711984.1285260826.1684863360-632779402.1650327311">acesse este artigo para saber quando usar cada um</a></p><p style="margin-left:0px;">&nbsp;</p><p style="margin-left:0px;">Esse valor é custeado tanto pelo lojista quanto pelo Olist. A porcentagem de desconto que oferecemos pode chegar a até 50% e varia conforme:</p><p style="margin-left:0px;"><strong>Os indicadores de operação da loja</strong>: chamada de seller index, essa nota vai de 1 a 5, em que 5 representa ótima performance operacional – <a href="https://ajuda.olist.com/hc/pt-br/articles/4409172797332-Como-funcionam-os-indicadores-de-opera%C3%A7%C3%A3o-de-olist-store">saiba mais</a>. Quanto maior a nota, mais desconto o lojista ganhará no frete.</p><p style="margin-left:0px;"><strong>A forma de envio</strong>: oferecemos a opção com coleta ou sem coleta do Olist. Ao usar nosso programa de coleta, o lojista ganha mais desconto no frete. Entenda aqui como funciona essa modalidade e quais cidades ela atende.</p><p style="margin-left:0px;">&nbsp;</p><p style="margin-left:0px;"><a href="https://ajuda.olist.com/hc/pt-br/articles/4409162517524-Como-funcionam-as-regras-de-comiss%C3%A3o-e-frete-do-Olist-Store-">Para saber mais detalhes sobre o frete e a porcentagem de desconto, clique aqui.</a></p>',
    },
    {
      id: 33,
      question: '<p>Se eu vender mais de um item por pedido, como será o cálculo do meu frete?</p>',
      answer:
        '<p style="margin-left:0px;">Nos produtos abaixo de R$ 79, quem paga o valor do frete é o consumidor. Para produtos com valor igual ou acima de R$ 79, o que vale é a tabela de frete do Olist, que têm entrega grátis para o cliente final e varia de acordo com os três fatores: região de expedição, quantidade de produtos enviados e peso do produto, que pode ser o <a href="https://ajuda.olist.com/hc/pt-br/articles/4409264907028-Como-calcular-o-peso-do-frete?_gl=1*j91rt1*_gcl_au*MTg0NzQ4NzE4Ny4xNjgxNzUzNTI4&amp;_ga=2.2711984.1285260826.1684863360-632779402.1650327311">peso físico ou cúbico</a>.</p><p style="margin-left:0px;">&nbsp;</p><p style="margin-left:0px;">A porcentagem de desconto que oferecemos pode chegar a até 50% e varia conforme os <a href="https://ajuda.olist.com/hc/pt-br/articles/4409172797332-Como-funcionam-os-indicadores-de-opera%C3%A7%C3%A3o-de-olist-store">indicadores de operação da loja</a> e a forma de envio.</p><p style="margin-left:0px;">&nbsp;</p><p style="margin-left:0px;">Se o consumidor final comprar produtos diferentes do mesmo lojista (uma caneta, um caderno e um estojo, por exemplo), será cobrado o valor do frete de cada produto. Neste cenário, quem paga o valor é o lojista em coparticipação com o Olist.</p><p style="margin-left:0px;">&nbsp;</p><p style="margin-left:0px;">Lembrando que há uma taxa fixa de R$ 5 por item vendido.</p><p style="margin-left:0px;">&nbsp;</p><p style="margin-left:0px;"><a href="https://ajuda.olist.com/hc/pt-br/articles/4409162517524-Como-funcionam-as-regras-de-comiss%C3%A3o-e-frete-do-Olist-Store-">Clique aqui e saiba mais sobre como funcionam as regras de frete do Olist, com preços competitivos para impulsionar as suas vendas.</a></p>',
    },
    {
      id: 34,
      question:
        '<p>Em casos de frete grátis, a cidade ou estado para qual o pedido será enviado influencia no valor do frete?</p>',
      answer:
        '<p style="margin-left:0px;">Não. A tabela de frete é baseada na região em que o lojista está e também no peso do produto. Dessa forma, se o consumidor for da região norte e o pedido for expedido da região sudeste, o lojista pagará o valor de frete tabelado para a região sudeste.</p><p style="margin-left:0px;">&nbsp;</p><p style="margin-left:0px;">Lembrando que o Olist coparticipa no pagamento do frete.</p><p style="margin-left:0px;">&nbsp;</p><p style="margin-left:0px;"><a href="https://ajuda.olist.com/hc/pt-br/articles/4409162919700-Como-funcionam-as-tabelas-de-frete-do-Olist">Confira aqui a tabela de frete exclusiva do Olist</a>, com preços competitivos para impulsionar as suas vendas.</p>',
    },
    {
      id: 35,
      question: '<p>Em caso de devolução do pedido, como será cobrado o frete?</p>',
      answer:
        '<p style="margin-left:0px;">Em caso de devolução do pedido por parte do consumidor, quem arca com o custo do frete é o lojista, tanto nos produtos abaixo de R$ 79,00 quanto naqueles com valor igual ou superior.</p><p style="margin-left:0px;">&nbsp;</p><p style="margin-left:0px;">*O custo do frete em caso de devolução é tabelado pelos Correios. Para mais informações, acesse o site da instituição.</p>',
    },
    {
      id: 36,
      question: '<p>A comissão do Olist já inclui a comissão dos marketplaces?</p>',
      answer:
        '<p>Sim! A comissão do Olist já engloba as taxas cobradas pelos marketplaces parceiros. Dessa forma, você não precisa arcar com nenhum outro tipo de tarifa externa.</p>',
    },
    {
      id: 37,
      question: '<p>Quais são os requisitos para vender com o Olist?</p>',
      answer:
        '<p style="margin-left:0px;">Um dos requisitos para vender com o Olist é emitir Nota Fiscal Eletrônica (NF-e) em formato XML e com chave de acesso digital. Então se você é MEI (Microempreendedor Individual) pode vender com o olist desde que emita NF-e. Além disso, aceitamos somente lojas que trabalham com as categorias regulamentadas pelos canais de venda parceiros.</p><p style="margin-left:0px;">&nbsp;</p><p style="margin-left:0px;">NÃO comercializamos serviços, itens de moda/vestuário e produtos usados, por exemplo.</p><p style="margin-left:0px;">&nbsp;</p><p style="margin-left:0px;"><a href="https://olist.com/pt-br/solucoes-para-comercio/vender-em-marketplaces/categorias-restritas/">Confira aqui a lista completa de produtos proibidos.</a></p>',
    },
    {
      id: 38,
      question: '<p>Em quais marketplaces o Olist está presente?</p>',
      answer:
        '<p>O Olist está presente em mais de 15 marketplaces diferentes. Confira a lista completa dos sites parceiros: Amazon, Americanas.com, Carrefour, Casa &amp; Video, Casas Bahia, Cobasi, Extra.com, , Inter, MadeiraMadeira, Magalu, Mercado Livre, Pontofrio, Shoptime, Submarino, Vivo Shopping e Zoom.</p>',
    },
    {
      id: 39,
      question: '<p>Quais são as integrações do Olist?</p>',
      answer:
        '<p style="margin-left:0px;">Pensando em facilitar a gestão das vendas de nossos lojistas, o Olist está integrado a diversos ERPs, plataformas de e-commerce e hubs. A nossa lista de parceiros inclui as seguintes empresas: Bling, Tray, VHSYS, Tiny, BizCommerce, iSET, F1 Commerce, BSeller. O Olist também tem integração exclusiva com a transportadora privada Jadlog, o que permite uma melhor performance das entregas e custos de frete reduzidos.</p><p style="margin-left:0px;">&nbsp;</p><p style="margin-left:0px;"><a href="https://olist.com/pt-br/integracoes-parcerias-tecnicas/">Saiba mais sobre as integrações do Olist.</a></p>',
    },
    {
      id: 40,
      question: '<p>Como funciona o serviço de coleta do Olist?</p>',
      answer:
        '<p style="margin-left:0px;">O envio de todas as vendas processadas em Olist serão coletadas diariamente pelo time Olist-PAX no endereço informado no cadastro, em no máximo 24h. Assim você ganha mais praticidade na operação e prazos de entrega 70% menores, alavancando a conversão dos seus anúncios nos canais de venda.</p><p style="margin-left:0px;">&nbsp;</p><p style="margin-left:0px;">O serviço de coleta Olist-PAX atende:</p><p style="margin-left:0px;">&nbsp;</p><p style="margin-left:0px;">Capitais e região metropolitana:</p><ul style="list-style-type:disc;"><li>São Paulo</li><li>Rio de Janeiro</li><li>Belo Horizonte</li><li>Curitiba</li><li>Porto Alegre</li></ul><p style="margin-left:0px;">&nbsp;</p><p style="margin-left:0px;">Demais cidades:</p><ul style="list-style-type:disc;"><li>Campinas</li><li>Sorocaba</li><li>São José dos Campos</li><li>Ibitinga</li></ul><p style="margin-left:0px;">&nbsp;</p><p style="margin-left:0px;">Próximas regiões:</p><ul style="list-style-type:disc;"><li>Vitória</li><li>Salvador</li><li>Recife</li><li>Florianópolis</li><li>Vale do Itajaí</li></ul><p style="margin-left:0px;">&nbsp;</p><p style="margin-left:0px;">*Avaliaremos a disponibilidade da coleta de acordo com seu CEP</p><p style="margin-left:0px;">&nbsp;</p><p style="margin-left:0px;">**Demais regiões são atendidas pelos Correios e transportadoras parceiras de Olist.</p>',
    },
    {
      id: 41,
      question: '<p>Quais as vantagens de enviar o pedido em 24 horas?</p>',
      answer:
        '<p style="margin-left:0px;">No e-commerce, o prazo de entrega de um produto pode ser o seu maior aliado ou o seu pior detrator. Isso porque quanto menor o tempo de entrega, maiores são as chances do cliente escolher o seu produto e não o do concorrente.</p><p style="margin-left:0px;">&nbsp;</p><p style="margin-left:0px;">Estudos de mercado apontam que a demora na entrega é a responsável pela desistência de 55% a 77% das compras online. Já os produtos com envio em menos de 24 horas têm um aumento médio de 48% na taxa de conversão. Ou seja, 48% mais vendas.</p><p style="margin-left:0px;">&nbsp;</p><p style="margin-left:0px;">Para que os lojistas de Olist gerem ainda mais pedidos em seus anúncios, orientamos que o tempo de operação da venda – entre recebimento do pedido na plataforma e postagem nos Correios ou transportadoras – <strong>seja de 24 horas em dias úteis.</strong>&nbsp;</p><p style="margin-left:0px;">&nbsp;</p><p style="margin-left:0px;">Imprimir essa agilidade na operação aumenta a sua taxa de conversão e garante giro de estoque e liquidez de vendas constantes.</p><p style="margin-left:0px;">&nbsp;</p><p style="margin-left:0px;"><i>Para apoiar o seu negócio nesta etapa e otimizar seu prazo de entrega, conte com o serviço de coleta de Olist, disponível no plano Crescer, Evoluir e Potencializar.</i></p>',
    },
  ],
  banner: {
    id: 5,
    title: 'Seja mais competitivo nos marketplaces\ncom o Olist',
    button_title: 'criar conta',
    button_link: null,
    description:
      '<p>Cadastre-se e comece a sua operação de vendas com o <strong>Olist</strong> hoje mesmo</p>',
  },
  main_resources: [
    { id: 1, content: '<p>Comissão dos marketplaces <strong>já inclusa</strong></p>' },
    { id: 3, content: '<p>Campanhas de <strong>vendas exclusivas</strong></p>' },
    { id: 5, content: '<p><strong>Atendimento pós-venda </strong>aos clientes da sua loja</p>' },
    { id: 4, content: '<p>Coleta <strong>unificada</strong></p>' },
    { id: 2, content: '<p><strong>Alta relevância</strong> em até 10 marketplaces</p>' },
    {
      id: 11,
      content: '<p>Possibilidade de antecipar repasses com <strong>ótimas taxas</strong></p>',
    },
  ],
  modal_costs: [
    { id: 6, content: '<p><strong>comissão sobre o produto</strong></p>' },
    { id: 7, content: '<p><strong>R$ 5 por item</strong></p>' },
    {
      id: 8,
      content:
        '<p><strong>Frete</strong></p><p style="margin-left:0px;">para produtos acima de R$ 79,00</p>',
    },
  ],
  modal_link: {
    id: 17,
    title: 'Saiba mais sobre as regras de comissionamento e frete do olist',
    link: 'https://ajuda.olist.com/hc/pt-br/articles/4409162517524-Como-funcionam-as-regras-de-comiss%C3%A3o-e-frete-do-Olist-Store-',
  },
  modal_explanations: [
    {
      id: 9,
      content:
        '<h2 style="margin-left:0px;">Comissão</h2><p style="margin-left:0px;">Incide sobre o valor de cada produto vendido.</p><p style="margin-left:0px;">Nossa comissão é calculada a partir das taxas de operação cobradas pelos canais (18%) + nossos custos operacionais (de 3% a 5%).</p><p style="margin-left:0px;">Ou seja, cobrimos as taxas de todos os marketplaces integrados e você não precisa pagar <strong>nada a mais</strong> por isso.</p>',
    },
    {
      id: 10,
      content:
        '<h2 style="margin-left:0px;">Frete</h2><p style="margin-left:0px;">Cobramos uma taxa <strong>fixa de R$ 5 por item vendido.</strong></p><p style="margin-left:0px;">Esse valor incide sobre cada unidade vendida. Exemplo: se o cliente comprar 2 itens, será cobrado um total de R$ 10 (R$ 5 por unidade).</p><p style="margin-left:0px;">Além disso, para produtos com valor igual ou acima de R$ 79, o frete é grátis para o consumidor, e esse custo é compartilhado entre o Olist e o lojista.</p><p style="margin-left:0px;">Além disso, o Olist conta com uma tabela de frete exclusiva, em que o lojista pode obter até 50% de desconto sobre o valor do envio.</p>',
    },
  ],
  localizations: { data: [] },
};
